module.exports = __webpack_public_path__ + "static/img/课堂bg@2x.2bfe2ad8.png";